import { PaymentAndGiftCardsScreen } from '../../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return <PaymentAndGiftCardsScreen />;
}
